'use client';

import { PropsWithChildren } from 'react';
import { usePathname } from 'next/navigation';

import { routesWithoutNavigation } from '../../config/routes';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import styles from './NavigationLayout.module.scss';

const NavigationLayout = (props: PropsWithChildren) => {
  const { children } = props;

  const pathname = usePathname();

  if (routesWithoutNavigation.some((r) => r.test(pathname))) {
    return children;
  }

  return (
    <>
      <Header />

      <div id="main-scope" className={styles.mainScope}>
        <main className={styles.main}>{children}</main>

        <Footer />
      </div>
    </>
  );
};

export default NavigationLayout;
